import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import NeuralNetwork from '../components/NeuralNetwork';

function About() {
  const teamMembers = [
    { name: 'Alex Graham', title: 'Director and Founder', image: '/images/team/alex head shot.jpg' },
    { name: 'Tom Strawford', title: 'Data Scientist', image: '/images/team/tom headshot.jpg' },
    { name: 'Ryan D\'Souza', title: 'Data Scientist', image: '/images/team/ryan headshot.jpg' },
    { name: 'Alexander Farquharson', title: 'Data Scientist', image: '/images/team/alex F headshot.jpg' },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>About Clariti AI | Banking Pricing Experts</title>
        <meta name="description" content="Learn about Clariti AI, a bank pricing optimisation software company helping global mortgage and savings teams make better data-driven decisions." />
        <link rel="canonical" href="https://www.clariti.ai/about" />
        <meta property="og:title" content="About Clariti AI | Banking Pricing Experts" />
        <meta property="og:description" content="Meet the team behind Clariti AI and our approach to global banking pricing analytics." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.clariti.ai/about" />
        <meta name="twitter:title" content="About Clariti AI | Banking Pricing Experts" />
        <meta name="twitter:description" content="Learn how Clariti AI helps banks improve pricing decisions with advanced analytics." />
      </Helmet>
      {/* Hero */}
      <section className="about-hero">
        <NeuralNetwork className="nn-layer" nodeCount={40} interactive={true} />
        <div className="container">
          <h1>About Clariti AI</h1>
          <p>We help banks make smarter pricing decisions. It's what we've done for over 15 years.</p>
        </div>
      </section>

      {/* Dark Band */}
      <section className="section-dark-band">
        <div className="container">
          <h2>Built for pricing teams</h2>
          <p>We combine deep banking expertise with advanced analytics to help teams move faster with confidence.</p>
        </div>
      </section>

      {/* Our Story */}
      <section className="story-section" style={{ position: 'relative' }}>
        <NeuralNetwork className="nn-layer" nodeCount={20} interactive={false} />
        <div className="container">
          <div className="story-content">
            <h2>Rooted in expertise</h2>
            <p>
              Clariti AI was founded on a simple belief: pricing teams deserve better tools. 
              With over 15 years of experience working alongside mortgage and savings teams, 
              we've seen what works — and what doesn't. We continually innovate and use groundbreaking methodologies to constantly improve our approach.
            </p>
            <p>
              We built Clariti AI to give banks a platform that evolves with them. Not a 
              one-off project that gathers dust, but a continuously improving solution backed 
              by a team that's genuinely invested in your success.
            </p>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="story-section section-light" style={{ position: 'relative' }}>
        <NeuralNetwork className="nn-layer" nodeCount={18} interactive={false} />
        <div className="container">
          <div className="story-content">
            <h2>A long-term partnership</h2>
            <p>
              Pricing optimisation isn't a one-time fix. Markets shift, customer behaviour 
              changes, and your strategy evolves. We're with you for the long haul — continuously 
              improving the platform, refining models, and supporting your team as your needs grow.
            </p>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section team-section" style={{ position: 'relative' }}>
        <NeuralNetwork className="nn-layer" nodeCount={20} interactive={false} />
        <div className="container">
          <div className="section-header">
            <h2>Meet the team</h2>
            <p>
              A dedicated team of data scientists, engineers, and pricing experts 
              with deep expertise in banking — all focused on one thing: helping banks price smarter.
            </p>
          </div>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-member">
                <div className="team-photo">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    loading="lazy"
                  />
                </div>
                <h4>{member.name}</h4>
                <p>{member.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="location-section section-light">
        <div className="container">
          <h3>Based in London, but with a global reach</h3>
          <p>Our team is headquartered in London, working with banks across the UK and Europe.</p>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <NeuralNetwork className="nn-layer" nodeCount={30} interactive={true} />
        <div className="container">
          <div className="cta-content">
            <h2>Join us or get in touch</h2>
            <p>
              Interested in joining the team or want to learn more about what we do?
            </p>
            <div className="cta-button-group">
              <Link to="/careers" className="btn btn-white">View Careers</Link>
              <Link to="/contact" className="btn btn-white">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
